import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/settings/preferences/")({
  beforeLoad: () => {
    throw redirect({
      to: "/settings/preferences/languages",
    })
  },
})
